<template>
    <div>
        <base-header type="primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <div>
                <div class="header-body">
                    <div class="row">
                        <div class="col-xl-3 col-lg-6">
                            <div class="card card-stats mb-4 mb-xl-0" show-footer-line="true">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="card-title text-uppercase text-muted mb-0">Total documents</h5>
                                            <span class="h2 font-weight-bold mb-0">{{analyticsData.totalDocs}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-orange">
                                                <i class="fas fa-file"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mt-3 mb-0 text-sm">
                                        <span :class="analyticsData.growPercent >= 0 ? 'text-success mr-2':'text-danger mr-2'"><i :class="analyticsData.growPercent >= 0 ? 'fa fa-arrow-up':'fa fa-arrow-down'"></i> {{analyticsData.growPercent}}%</span>
                                        <span class="text-nowrap">Since last month</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row mt-5">
                <div class="col-12 mb-4">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0"><span class="text-primary">1.</span> Quotation requests submitted by users</h3>
                                </div>
                                <div class="col text-right">
                                    <button class="btn btn-success" v-on:click="saveTable(0)">
                                        <i class="fas fa-save"> Save</i>
                                    </button>
                                    <router-link :to="{ name: 'policies' }" class=" btn btn-primary">See all</router-link>
                                </div>
                            </div>

                        </div>
                        <b-table id="firstTable"
                                 :items="newRequests"
                                 :fields="newRequestsFields"
                                 :sort-by.sync="sortBy[0]"
                                 :sort-desc.sync="sortDesc[0]"
                                 :per-page="quantityPerPage"
                                 :current-page="currentPageTables[0]"
                                 responsive
                                 fixed
                                 striped
                                 show-empty>
                            <template #cell(documentId)="id">
                                <router-link :to="{ name: 'task update', params: { id: id.value } }"
                                             class="text-info font-weight-bold text-uppercase">
                                    {{id.value}}
                                </router-link>
                            </template>
                            <template #head(reviewByBroker)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 0)" v-model="allSelectedColumns[0]" :disabled="allSelectedColumns[0]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(reviewByBroker)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.reviewByBroker" :disabled="cell.item.reviewByBroker"></base-checkbox>
                            </template>
                            <template #head(sendFilesToTheInsuranceCompany)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 0)" v-model="allSelectedColumns[1]" :disabled="!allSelectedColumns[0] || allSelectedColumns[1]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(sendFilesToTheInsuranceCompany)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.sendFilesToTheInsuranceCompany" :disabled="!cell.item.reviewByBroker || cell.item.sendFilesToTheInsuranceCompany"></base-checkbox>
                            </template>
                            <template #head(quotationReceivedFromTheInsuranceCompany)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 0)" v-model="allSelectedColumns[2]" :disabled="!allSelectedColumns[1] || allSelectedColumns[2]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(quotationReceivedFromTheInsuranceCompany)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.quotationReceivedFromTheInsuranceCompany" :disabled="!cell.item.sendFilesToTheInsuranceCompany || cell.item.quotationReceivedFromTheInsuranceCompany"></base-checkbox>
                            </template>

                        </b-table>

                        <b-pagination v-model="currentPageTables[0]"
                                      :total-rows="getFirstTableItemsCount"
                                      :per-page="quantityPerPage"
                                      aria-controls="firstTable"
                                      class="ml-4">
                        </b-pagination>
                    </div>
                </div>
                <div class="col-12 mb-4">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0"><span class="text-primary">2.</span> Quotation uploaded to user</h3>
                                </div>
                                <div class="col text-right">
                                    <button class="btn btn-success" v-on:click="saveTable(1)">
                                        <i class="fas fa-save"> Save</i>
                                    </button>
                                    <router-link :to="{ name: 'policies' }" class=" btn btn-primary">See all</router-link>
                                </div>
                            </div>
                        </div>
                        <b-table id="secondTable"
                                 :items="stepTwoRequests"
                                 :fields="stepTwoRequestsFields"
                                 :sort-by.sync="sortBy[1]"
                                 :sort-desc.sync="sortDesc[1]"
                                 :per-page="quantityPerPage"
                                 :current-page="currentPageTables[1]"
                                 responsive
                                 fixed
                                 striped
                                 show-empty>
                            <template #cell(documentId)="id">
                                <router-link :to="{ name: 'task update', params: { id: id.value } }"
                                             class="text-info font-weight-bold text-uppercase">
                                    {{id.value}}
                                </router-link>
                            </template>
                            <template #head(notificationSentToTheUser)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 1)" v-model="allSelectedColumns[3]" :disabled="allSelectedColumns[3]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(notificationSentToTheUser)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.notificationSentToTheUser" :disabled="cell.item.notificationSentToTheUser"></base-checkbox>
                            </template>
                            <template #head(ensureThatWeUploadTheCorrectQuotation)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 1)" v-model="allSelectedColumns[4]" :disabled="!allSelectedColumns[3] || allSelectedColumns[4]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(ensureThatWeUploadTheCorrectQuotation)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.ensureThatWeUploadTheCorrectQuotation" :disabled="!cell.item.notificationSentToTheUser || cell.item.ensureThatWeUploadTheCorrectQuotation"></base-checkbox>
                            </template>
                            <template #head(timeLeftToAcceptTheQuotation)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 1)" v-model="allSelectedColumns[5]" :disabled="!allSelectedColumns[4] || allSelectedColumns[5]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(timeLeftToAcceptTheQuotation)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.timeLeftToAcceptTheQuotation" :disabled="!cell.item.ensureThatWeUploadTheCorrectQuotation || cell.item.timeLeftToAcceptTheQuotation"></base-checkbox>
                            </template>
                        </b-table>

                        <b-pagination v-model="currentPageTables[1]"
                                      :total-rows="getSecondTableItemsCount"
                                      :per-page="quantityPerPage"
                                      aria-controls="secondTable"
                                      class="ml-4">
                        </b-pagination>
                    </div>
                </div>
                <div class="col-12 mb-4">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0"><span class="text-primary">3.</span> Received acceptance from customer</h3>
                                </div>
                                <div class="col text-right">
                                    <button class="btn btn-success" v-on:click="saveTable(2)">
                                        <i class="fas fa-save"> Save</i>
                                    </button>
                                    <router-link :to="{ name: 'policies' }" class=" btn btn-primary">See all</router-link>
                                </div>
                            </div>
                        </div>
                        <b-table id="thirdTable"
                                 :items="stepThreeRequests"
                                 :fields="stepThreeRequestsFields"
                                 :sort-by.sync="sortBy[2]"
                                 :sort-desc.sync="sortDesc[2]"
                                 :per-page="quantityPerPage"
                                 :current-page="currentPageTables[2]"
                                 responsive
                                 fixed
                                 striped
                                 show-empty>
                            <template #cell(documentId)="id">
                                <router-link :to="{ name: 'task update', params: { id: id.value } }"
                                             class="text-info font-weight-bold text-uppercase">
                                    {{id.value}}
                                </router-link>
                            </template>
                            <template #head(confirmationToUserPaymentReceivedAndPolicyIssueInProgress)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 2)" v-model="allSelectedColumns[6]" :disabled="allSelectedColumns[6]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(confirmationToUserPaymentReceivedAndPolicyIssueInProgress)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress" :disabled="cell.item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress"></base-checkbox>
                            </template>
                            <template #head(coverNoteIssued)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 2)" v-model="allSelectedColumns[7]" :disabled="!allSelectedColumns[6] || allSelectedColumns[7]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(coverNoteIssued)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.coverNoteIssued" :disabled="!cell.item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress || cell.item.coverNoteIssued"></base-checkbox>
                            </template>
                            <template #head(emailToTheInsuranceCompanyToIssueThePolicy)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 2)" v-model="allSelectedColumns[8]" :disabled="!allSelectedColumns[7] || allSelectedColumns[8]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(emailToTheInsuranceCompanyToIssueThePolicy)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.emailToTheInsuranceCompanyToIssueThePolicy" :disabled="!cell.item.coverNoteIssued || cell.item.emailToTheInsuranceCompanyToIssueThePolicy"></base-checkbox>
                            </template>
                        </b-table>

                        <b-pagination v-model="currentPageTables[2]"
                                      :total-rows="getThirdTableItemsCount"
                                      :per-page="quantityPerPage"
                                      aria-controls="thirdTable"
                                      class="ml-4">
                        </b-pagination>
                    </div>
                </div>
                <div class="col-12 mb-4">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0"><span class="text-primary">4.</span> Policy received from insurance company</h3>
                                </div>
                                <div class="col text-right">
                                    <button class="btn btn-success" v-on:click="saveTable(3)">
                                        <i class="fas fa-save"> Save</i>
                                    </button>
                                    <router-link :to="{ name: 'policies' }" class=" btn btn-primary">See all</router-link>
                                </div>
                            </div>
                        </div>
                        <b-table id="fourthTable"
                                 :items="stepFourRequests"
                                 :fields="stepFourRequestsFields"
                                 :sort-by.sync="sortBy[3]"
                                 :sort-desc.sync="sortDesc[3]"
                                 :per-page="quantityPerPage"
                                 :current-page="currentPageTables[3]"
                                 responsive
                                 fixed
                                 striped
                                 show-empty>
                            <template #cell(documentId)="id">
                                <router-link :to="{ name: 'task update', params: { id: id.value } }"
                                             class="text-info font-weight-bold text-uppercase">
                                    {{id.value}}
                                </router-link>
                            </template>
                            <template #head(notificationToTheUserYourPolicyHasBeenIssued)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 3)" v-model="allSelectedColumns[9]" :disabled="allSelectedColumns[9]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(notificationToTheUserYourPolicyHasBeenIssued)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.notificationToTheUserYourPolicyHasBeenIssued" :disabled="cell.item.notificationToTheUserYourPolicyHasBeenIssued"></base-checkbox>
                            </template>
                            <template #head(uploadThePolicyToTheCustomer)="head">
                                <div class="tableHeader">
                                    <base-checkbox @change="checkAll($event, head.column, 3)" v-model="allSelectedColumns[10]" :disabled="!allSelectedColumns[9] || allSelectedColumns[10]"></base-checkbox>
                                    {{ head.label.toUpperCase() }}
                                </div>
                            </template>
                            <template #cell(uploadThePolicyToTheCustomer)="cell">
                                <base-checkbox class="mb-3" v-model="cell.item.uploadThePolicyToTheCustomer" :disabled="!cell.item.notificationToTheUserYourPolicyHasBeenIssued || cell.item.uploadThePolicyToTheCustomer"></base-checkbox>
                            </template>
                        </b-table>

                        <b-pagination v-model="currentPageTables[3]"
                                      :total-rows="getFourthTableItemsCount"
                                      :per-page="quantityPerPage"
                                      aria-controls="fourthTable"
                                      class="ml-4">
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import firebase from '../config/db.js';
    import swal from 'sweetalert2';
    import moment from 'moment';
    import Vue from "vue";
    import { TablePlugin } from 'bootstrap-vue';
    Vue.use(TablePlugin);
    import { PaginationPlugin } from 'bootstrap-vue';
    Vue.use(PaginationPlugin);
    export default {
        data() {
            return {
                quantityPerPage: 3,
                analyticsData: {
                    totalDocs: 0,
                    previousMonth: 0,
                    currentMonth: 0,
                    growPercent: 0,
                },
                allSelectedColumns: [
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true
                ],
                subStatuses: new Map(),
                newRequests: [],
                stepTwoRequests: [],
                stepThreeRequests: [],
                stepFourRequests: [],
                currentPageTables: [1, 1, 1, 1],
                sortBy: ['created', 'created', 'created', 'created'],
                sortDesc: [true, true, true, true],
                newRequestsFields: [
                    { key: 'documentId', sortable: true, label: 'DOCUMENT ID' },
                    { key: 'proposer', sortable: true, label: 'PROPOSER' },
                    { key: 'created', sortable: true, label: 'CREATED', formatter: 'dateToString' },
                    { key: 'reviewByBroker', sortable: false, label: 'REVIEW BY BROKER' },
                    { key: 'sendFilesToTheInsuranceCompany', sortable: false, label: 'SEND FILES TO THE INSURANCE COMPANY' },
                    { key: 'quotationReceivedFromTheInsuranceCompany', sortable: false, label: 'QUOTATION RECEIVED FROM THE INSURANCE COMPANY' },
                ],
                stepTwoRequestsFields: [
                    { key: 'documentId', sortable: true, label: 'DOCUMENT ID' },
                    { key: 'proposer', sortable: true, label: 'PROPOSER' },
                    { key: 'created', sortable: true, label: 'CREATED', formatter: 'dateToString' },
                    { key: 'notificationSentToTheUser', sortable: false, label: 'NOTIFICATION SENT TO THE USER' },
                    { key: 'ensureThatWeUploadTheCorrectQuotation', sortable: false, label: 'ENSURE THAT WE UPLOAD THE CORRECT QUOTATION' },
                    { key: 'timeLeftToAcceptTheQuotation', sortable: false, label: 'TIME LEFT TO ACCEPT THE QUOTATION' }
                ],
                stepThreeRequestsFields: [
                    { key: 'documentId', sortable: true, label: 'DOCUMENT ID' },
                    { key: 'proposer', sortable: true, label: 'PROPOSER' },
                    { key: 'created', sortable: true, label: 'CREATED', formatter: 'dateToString' },
                    { key: 'confirmationToUserPaymentReceivedAndPolicyIssueInProgress', sortable: false, label: 'CONFIRMATION TO USER PAYMENT RECEIVED AND POLICY ISSUE IN PROGRESS' },
                    { key: 'coverNoteIssued', sortable: false, label: 'COVER NOTE ISSUED' },
                    { key: 'emailToTheInsuranceCompanyToIssueThePolicy', sortable: false, label: 'EMAIL TO THE INSURANCE COMPANY TO ISSUE THE POLICY' },
                ],
                stepFourRequestsFields: [
                    { key: 'documentId', sortable: true, label: 'DOCUMENT ID' },
                    { key: 'proposer', sortable: true, label: 'PROPOSER' },
                    { key: 'created', sortable: true, label: 'CREATED', formatter: 'dateToString' },
                    { key: 'notificationToTheUserYourPolicyHasBeenIssued', sortable: false, label: 'NOTIFICATION TO THE USER YOUR POLICY HAS BEEN ISSUED' },
                    { key: 'uploadThePolicyToTheCustomer', sortable: false, label: 'UPLOAD THE POLICY TO THE CUSTOMER' }
                ]
            };
        },
        methods: {
            watchAllRequests: function () {
                var today = new Date();
                var currentMonth = new Date();
                var previousMonth = new Date();
                var currentMonthNumber = today.getMonth();
                var currentDayNumber = today.getDate();
                currentMonth.setMonth(currentMonthNumber === 0 ? 11 : currentMonthNumber - 1);
                previousMonth.setMonth(currentMonthNumber === 0 ? 10 : currentMonthNumber === 1 ? 11 : currentMonthNumber - 2);
                if (currentDayNumber > 28) {
                    // Avoid undefined date for February and 30-days months
                    currentMonth.setDate(28);
                    previousMonth.setDate(28);
                }
                var newList = [];
                var stepTwoList = [];
                var stepThreeList = [];
                var stepFourList = [];
                var that = this;
                firebase.firestore().collection("policies").orderBy("created", 'desc').onSnapshot(querySnapshot => {
                    that.analyticsData.totalDocs = querySnapshot.docs.length;
                    that.analyticsData.currentMonth = querySnapshot.docs.filter(doc => doc.data().created.toDate() > currentMonth).length;
                    that.analyticsData.previousMonth = querySnapshot.docs.filter(doc => doc.data().created.toDate() >= previousMonth && doc.data().created.toDate() < currentMonth).length;
                    that.analyticsData.growPercent = Math.round((that.analyticsData.currentMonth - that.analyticsData.previousMonth) * 10000 / (that.analyticsData.previousMonth > 0 ? that.analyticsData.previousMonth : 1)) / 100;
                    newList = [];
                    stepTwoList = [];
                    stepThreeList = [];
                    stepFourList = [];
                    querySnapshot.forEach((doc) => {
                        var proposer = doc.data().proposer ? doc.data().proposer : '–';
                        var internalStatus = doc.data().internalStatus;
                        var internalSubStatuses = doc.data().internalSubStatuses;
                        that.subStatuses.set(doc.id, internalSubStatuses);
                        switch (internalStatus) { // Can be 0, 1, 2 or 3. Default is 0 for new documants.
                            default:
                            case 0:
                                var reviewByBroker = false;
                                var sendFilesToTheInsuranceCompany = false;
                                var quotationReceivedFromTheInsuranceCompany = false;
                                if (doc.data().internalStatus >= 0 && doc.data().internalSubStatuses && doc.data().internalSubStatuses.length > 0) {
                                    var brokerObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 1 // Review by broker
                                    })
                                    var sendFilesToTheInsuranceCompanyObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 2 // Send by email/upload files to the Insurance company
                                    })
                                    var quotationReceivedFromTheInsuranceCompanyObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 3 // Quotation received from the Insurance company
                                    })
                                    reviewByBroker = brokerObject.completed;
                                    sendFilesToTheInsuranceCompany = sendFilesToTheInsuranceCompanyObject.completed;
                                    quotationReceivedFromTheInsuranceCompany = quotationReceivedFromTheInsuranceCompanyObject.completed;
                                }
                                newList.push({
                                    documentId: doc.id,
                                    proposer: proposer,
                                    created: doc.data().created.toDate(),
                                    reviewByBroker: reviewByBroker,
                                    sendFilesToTheInsuranceCompany: sendFilesToTheInsuranceCompany,
                                    quotationReceivedFromTheInsuranceCompany: quotationReceivedFromTheInsuranceCompany
                                });
                                if (!reviewByBroker)
                                    this.allSelectedColumns[0] = false;
                                if (!sendFilesToTheInsuranceCompany)
                                    this.allSelectedColumns[1] = false;
                                if (!quotationReceivedFromTheInsuranceCompany)
                                    this.allSelectedColumns[2] = false;
                                break;
                            case 1:
                                var notificationSentToTheUser = false;
                                var ensureThatWeUploadTheCorrectQuotation = false;
                                var timeLeftToAcceptTheQuotation = false;
                                if (internalSubStatuses && internalSubStatuses.length > 0) {
                                    var notificationSentToTheUserStatus = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 4 // Notification sent to the user
                                    })
                                    var ensureThatWeUploadTheCorrectQuotationStatus = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 5 // Ensure that we upload the correct quotation
                                    })
                                    var timeLeftToAcceptTheQuotationStatus = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 6 // Quotation sent to the user
                                    })
                                    notificationSentToTheUser = notificationSentToTheUserStatus.completed;
                                    ensureThatWeUploadTheCorrectQuotation = ensureThatWeUploadTheCorrectQuotationStatus.completed;
                                    timeLeftToAcceptTheQuotation = timeLeftToAcceptTheQuotationStatus.completed;
                                }
                                stepTwoList.push({
                                    documentId: doc.id,
                                    proposer: proposer,
                                    created: doc.data().created.toDate(),
                                    notificationSentToTheUser: notificationSentToTheUser,
                                    ensureThatWeUploadTheCorrectQuotation: ensureThatWeUploadTheCorrectQuotation,
                                    timeLeftToAcceptTheQuotation: timeLeftToAcceptTheQuotation
                                });
                                if (!notificationSentToTheUser)
                                    this.allSelectedColumns[3] = false;
                                if (!ensureThatWeUploadTheCorrectQuotation)
                                    this.allSelectedColumns[4] = false;
                                if (!timeLeftToAcceptTheQuotation)
                                    this.allSelectedColumns[5] = false;
                                break;
                            case 2:
                                var paymentReceived = false;
                                var coverNoteIssued = false;
                                var issueTheInsuranceCertificate = false;
                                if (doc.data().internalStatus >= 0 && doc.data().internalSubStatuses && doc.data().internalSubStatuses.length > 0) {
                                    var paymentReceivedObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 7 // Confirmation to user: payment received, policy issue in progress
                                    })
                                    var coverNoteIssuedObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 8 // Cover note issued, notification sent to the user
                                    })
                                    var issueTheInsuranceCertificateObject = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 9 // Email to the insurance company to issue the policy with details of the payment
                                    })
                                    paymentReceived = paymentReceivedObject.completed;
                                    coverNoteIssued = coverNoteIssuedObject.completed;
                                    issueTheInsuranceCertificate = issueTheInsuranceCertificateObject.completed;
                                }
                                stepThreeList.push({
                                    documentId: doc.id,
                                    premium: doc.data().premium,
                                    confirmationToUserPaymentReceivedAndPolicyIssueInProgress: paymentReceived,
                                    coverNoteIssued: coverNoteIssued,
                                    emailToTheInsuranceCompanyToIssueThePolicy: issueTheInsuranceCertificate,
                                    proposer: proposer,
                                    currencyCode: doc.data().currencyCode,
                                    created: doc.data().created.toDate()
                                });
                                if (!paymentReceived)
                                    this.allSelectedColumns[6] = false;
                                if (!coverNoteIssued)
                                    this.allSelectedColumns[7] = false;
                                if (!issueTheInsuranceCertificate)
                                    this.allSelectedColumns[8] = false;
                                break;
                            case 3:
                                var notificationToTheUserYourPolicyHasBeenIssued = false;
                                var uploadThePolicyToTheCustomer = false;
                                if (internalSubStatuses && internalSubStatuses.length > 0) {
                                    var notificationToTheUserYourPolicyHasBeenIssuedStatus = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 10 // Notification to the user: your policy has been issued
                                    })
                                    var uploadThePolicyToTheCustomerStatus = internalSubStatuses[internalStatus].substatuses.find(substatus => {
                                        return substatus.id === 11 // Upload the policy to the customer
                                    })
                                    notificationToTheUserYourPolicyHasBeenIssued = notificationToTheUserYourPolicyHasBeenIssuedStatus.completed;
                                    uploadThePolicyToTheCustomer = uploadThePolicyToTheCustomerStatus.completed;
                                }
                                stepFourList.push({
                                    documentId: doc.id,
                                    proposer: proposer,
                                    created: doc.data().created.toDate(),
                                    notificationToTheUserYourPolicyHasBeenIssued: notificationToTheUserYourPolicyHasBeenIssued,
                                    uploadThePolicyToTheCustomer: uploadThePolicyToTheCustomer
                                });
                                if (!notificationToTheUserYourPolicyHasBeenIssued)
                                    this.allSelectedColumns[9] = false;
                                if (!uploadThePolicyToTheCustomer)
                                    this.allSelectedColumns[10] = false;
                                break;
                        }
                    });
                    that.newRequests = newList;
                    that.stepTwoRequests = stepTwoList;
                    that.stepThreeRequests = stepThreeList;
                    that.stepFourRequests = stepFourList;
                });
            },
            checkAll(event, column, status) {
                switch (status) {
                    case 0: {
                        this.newRequests.forEach(function (item) {
                            switch (column) {
                                case "reviewByBroker":
                                    item.reviewByBroker = event;
                                    break;
                                case "sendFilesToTheInsuranceCompany":
                                    item.sendFilesToTheInsuranceCompany = event;
                                    break;
                                case "quotationReceivedFromTheInsuranceCompany":
                                    item.quotationReceivedFromTheInsuranceCompany = event;
                                    break;
                            }
                        });
                        break;
                    }
                    case 1: {
                        this.stepTwoRequests.forEach(function (item) {
                            switch (column) {
                                case "notificationSentToTheUser":
                                    item.notificationSentToTheUser = event;
                                    break;
                                case "ensureThatWeUploadTheCorrectQuotation":
                                    item.ensureThatWeUploadTheCorrectQuotation = event;
                                    break;
                                case "timeLeftToAcceptTheQuotation":
                                    item.timeLeftToAcceptTheQuotation = event;
                                    break;
                            }
                        });
                        break;
                    }
                    case 2: {
                        this.stepThreeRequests.forEach(function (item) {
                            switch (column) {
                                case "confirmationToUserPaymentReceivedAndPolicyIssueInProgress":
                                    item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress = event;
                                    break;
                                case "coverNoteIssued":
                                    item.coverNoteIssued = event;
                                    break;
                                case "emailToTheInsuranceCompanyToIssueThePolicy":
                                    item.emailToTheInsuranceCompanyToIssueThePolicy = event;
                                    break;
                            }
                        });
                        break;
                    }
                    case 3: {
                        this.stepFourRequests.forEach(function (item) {
                            switch (column) {
                                case "notificationToTheUserYourPolicyHasBeenIssued":
                                    item.notificationToTheUserYourPolicyHasBeenIssued = event;
                                    break;
                                case "uploadThePolicyToTheCustomer":
                                    item.uploadThePolicyToTheCustomer = event;
                                    break;
                            }
                        });
                        break;
                    }
                }
            },
            saveTable(status) {
                var that = this;
                var subStatuses = this.subStatuses;
                var policies = firebase.firestore().collection("policies");

                swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    icon: "warning",
                    showCancelButton: !0,
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then(function (result) {
                    if (result.value) {
                        switch (status) {
                            case 0: {
                                that.newRequests.forEach(function (item) {
                                    var currentStatus = 0;
                                    var changed = false;
                                    var substatus = subStatuses.get(item.documentId);
                                    if (substatus !== undefined && substatus !== null && substatus.length !== 0) {
                                        if (substatus[status].substatuses[0].completed != item.reviewByBroker) {
                                            substatus[status].substatuses[0].completed = item.reviewByBroker;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[1].completed != item.sendFilesToTheInsuranceCompany) {
                                            substatus[status].substatuses[1].completed = item.sendFilesToTheInsuranceCompany;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[2].completed != item.quotationReceivedFromTheInsuranceCompany) {
                                            substatus[status].substatuses[2].completed = item.quotationReceivedFromTheInsuranceCompany;
                                            changed = true;
                                        }
                                        if (changed) {
                                            if (item.reviewByBroker && item.sendFilesToTheInsuranceCompany && item.quotationReceivedFromTheInsuranceCompany)
                                                currentStatus++;

                                            policies.doc(item.documentId).update({
                                                'internalStatus': currentStatus,
                                                'internalSubStatuses': substatus
                                            }).catch(function (error) {
                                                console.error("Error updating policy " + item.documentId, error);
                                            });
                                        }
                                    }
                                });
                                break;
                            }
                            case 1: {
                                that.stepTwoRequests.forEach(function (item) {
                                    var currentStatus = 1;
                                    var changed = false;
                                    var substatus = subStatuses.get(item.documentId);
                                    if (substatus !== undefined && substatus !== null && substatus.length !== 0) {
                                        if (substatus[status].substatuses[0].completed != item.notificationSentToTheUser) {
                                            substatus[status].substatuses[0].completed = item.notificationSentToTheUser;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[1].completed != item.ensureThatWeUploadTheCorrectQuotation) {
                                            substatus[status].substatuses[1].completed = item.ensureThatWeUploadTheCorrectQuotation;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[2].completed != item.timeLeftToAcceptTheQuotation) {
                                            substatus[status].substatuses[2].completed = item.timeLeftToAcceptTheQuotation;
                                            changed = true;
                                        }
                                        if (changed) {
                                            if (item.notificationSentToTheUser && item.ensureThatWeUploadTheCorrectQuotation && item.timeLeftToAcceptTheQuotation)
                                                currentStatus++;

                                            policies.doc(item.documentId).update({
                                                'internalStatus': currentStatus,
                                                'internalSubStatuses': substatus
                                            }).catch(function (error) {
                                                console.error("Error updating policy " + item.documentId, error);
                                            });
                                        }
                                    }
                                });
                                break;
                            }
                            case 2: {
                                that.stepThreeRequests.forEach(function (item) {
                                    var currentStatus = 2;
                                    var changed = false;
                                    var substatus = subStatuses.get(item.documentId);
                                    if (substatus !== undefined && substatus !== null && substatus.length !== 0) {
                                        if (substatus[status].substatuses[0].completed != item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress) {
                                            substatus[status].substatuses[0].completed = item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[1].completed != item.coverNoteIssued) {
                                            substatus[status].substatuses[1].completed = item.coverNoteIssued;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[2].completed != item.emailToTheInsuranceCompanyToIssueThePolicy) {
                                            substatus[status].substatuses[2].completed = item.emailToTheInsuranceCompanyToIssueThePolicy;
                                            changed = true;
                                        }
                                        if (changed) {
                                            if (item.confirmationToUserPaymentReceivedAndPolicyIssueInProgress && item.coverNoteIssued && item.emailToTheInsuranceCompanyToIssueThePolicy)
                                                currentStatus++;

                                            policies.doc(item.documentId).update({
                                                'internalStatus': currentStatus,
                                                'internalSubStatuses': substatus
                                            }).catch(function (error) {
                                                console.error("Error updating policy " + item.documentId, error);
                                            });
                                        }
                                    }
                                });
                                break;
                            }
                            case 3: {
                                that.stepFourRequests.forEach(function (item) {
                                    var changed = false;
                                    var substatus = subStatuses.get(item.documentId);
                                    if (substatus !== undefined && substatus !== null && substatus.length !== 0) {
                                        if (substatus[status].substatuses[0].completed != item.notificationToTheUserYourPolicyHasBeenIssued) {
                                            substatus[status].substatuses[0].completed = item.notificationToTheUserYourPolicyHasBeenIssued;
                                            changed = true;
                                        }
                                        if (substatus[status].substatuses[1].completed != item.uploadThePolicyToTheCustomer) {
                                            substatus[status].substatuses[1].completed = item.uploadThePolicyToTheCustomer;
                                            changed = true;
                                        }

                                        if (changed) {
                                            policies.doc(item.documentId).update({
                                                'internalStatus': status,
                                                'internalSubStatuses': substatus
                                            }).catch(function (error) {
                                                console.error("Error updating policy " + item.documentId, error);
                                            });
                                        }
                                    }
                                });
                                break;
                            }
                        }
                    }
                }, function (t) {
                    "cancel" === t // Cancelled
                });
            },
            dateToString: function (value) {
                if (!value || typeof value === 'undefined') {
                    return "N/A";
                } else if (value instanceof Date) {
                    return moment(value).format('MMMM Do YYYY, h:mm:ss A');
                }
                return "N/A";
            }
        },
        created() {
            //this.watchAllRequests();
        },
        mounted() {
            this.watchAllRequests();
        },
        computed: {
            getFirstTableItemsCount() {
                return this.newRequests.length;
            },
            getSecondTableItemsCount() {
                return this.stepTwoRequests.length;
            },
            getThirdTableItemsCount() {
                return this.stepThreeRequests.length;
            },
            getFourthTableItemsCount() {
                return this.stepFourRequests.length;
            }
        }
    };
</script>
<style>
    .tableHeader {
        display: flex;
        align-items: center;
    }
</style>
